import {useParams} from "react-router-dom";
import {useQuery} from "react-query";
import FormPreview from "./FormPreview";
import {FormService} from "crqlar-react-common/dist/services/forms/form.service";

const PublicFormPreview = () => {
    const {id} = useParams();

    // Query for document templates
    const formQ = useQuery({
        queryKey: ['publicForm', id],
        queryFn: async () => {
            return await FormService.getFormByIdPublic(id!)
        },
        enabled: !!id
    });

    if (!formQ.data) {
        return null
    }

    return (
        <FormPreview form={formQ.data} isPublic={true}/>
    )
}

export default PublicFormPreview;